"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationRequesterSummaryDto = instanceOfOrientationRequesterSummaryDto;
exports.OrientationRequesterSummaryDtoFromJSON = OrientationRequesterSummaryDtoFromJSON;
exports.OrientationRequesterSummaryDtoFromJSONTyped = OrientationRequesterSummaryDtoFromJSONTyped;
exports.OrientationRequesterSummaryDtoToJSON = OrientationRequesterSummaryDtoToJSON;
exports.OrientationRequesterSummaryDtoToJSONTyped = OrientationRequesterSummaryDtoToJSONTyped;
/**
 * Check if a given object implements the OrientationRequesterSummaryDto interface.
 */
function instanceOfOrientationRequesterSummaryDto(value) {
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('avatar' in value) || value['avatar'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    if (!('requestedAt' in value) || value['requestedAt'] === undefined)
        return false;
    if (!('isNewRequest' in value) || value['isNewRequest'] === undefined)
        return false;
    return true;
}
function OrientationRequesterSummaryDtoFromJSON(json) {
    return OrientationRequesterSummaryDtoFromJSONTyped(json, false);
}
function OrientationRequesterSummaryDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'id': json['id'] == null ? undefined : json['id'],
        'avatar': json['avatar'],
        'message': json['message'],
        'requestedAt': (new Date(json['requestedAt'])),
        'isNewRequest': json['isNewRequest'],
    };
}
function OrientationRequesterSummaryDtoToJSON(json) {
    return OrientationRequesterSummaryDtoToJSONTyped(json, false);
}
function OrientationRequesterSummaryDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'id': value['id'],
        'avatar': value['avatar'],
        'message': value['message'],
        'requestedAt': ((value['requestedAt']).toISOString()),
        'isNewRequest': value['isNewRequest'],
    };
}
//# sourceMappingURL=OrientationRequesterSummaryDto.js.map